import { routeCreator } from "../../../helpers/routing/routeCreator";
import rates from "../pages/rates";



export const ROUTE_PAGE_RATES_INDEX = routeCreator(rates, '/rates', 'Rates', 'page.parameters', {exact: true})


const router = {
    ROUTE_PAGE_RATES_INDEX,
    
}

export default router